import React from 'react';

// Accent-color variant picker — small button with a color-dot swatch +
// label. Border + background lift to the variant's own accent when
// selected; otherwise borrows borderLight from the current theme.
// Extracted verbatim from prototypes/campaign-creation-prototype.jsx
// lines 1625-1655.
export const VariantTile = ({ variant, active, onClick, currentTheme }) => {
  const tc = currentTheme.colors;
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={!!active}
      style={{
        padding: '8px 10px',
        border: `1.5px solid ${active ? variant.accent : tc.borderLight}`,
        borderRadius: 6,
        background: active ? `${variant.accent}1a` : 'transparent',
        cursor: 'pointer',
        textAlign: 'left',
        transition: 'all 120ms ease',
        display: 'flex', alignItems: 'center', gap: 8,
      }}
    >
      <span style={{
        width: 14, height: 14,
        borderRadius: '50%',
        background: variant.accent,
        flex: '0 0 14px',
      }} />
      <span style={{
        fontSize: '0.84rem',
        color: active ? variant.accentLight : tc.textPrimary,
        fontFamily: currentTheme.typography?.fontFamily,
        fontWeight: 600,
      }}>{variant.name}</span>
    </button>
  );
};
